/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Thread
 */
export interface Thread {
    /**
     * 
     * @type {string}
     * @memberof Thread
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Thread
     */
    title: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Thread
     */
    metadata: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof Thread
     */
    pinned: boolean;
    /**
     * 
     * @type {string}
     * @memberof Thread
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Thread
     */
    updatedAt: string | null;
}

/**
 * Check if a given object implements the Thread interface.
 */
export function instanceOfThread(value: object): value is Thread {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('pinned' in value) || value['pinned'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ThreadFromJSON(json: any): Thread {
    return ThreadFromJSONTyped(json, false);
}

export function ThreadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Thread {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'metadata': json['metadata'],
        'pinned': json['pinned'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function ThreadToJSON(json: any): Thread {
    return ThreadToJSONTyped(json, false);
}

export function ThreadToJSONTyped(value?: Thread | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'metadata': value['metadata'],
        'pinned': value['pinned'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

